import { atom } from "recoil";

export const defaultProductNo = {
  productNo: "",
  productBno: "",
};
export const InvalidProductNo = {
  productNo: "999",
  productBno: "999",
};

export const productNoState = atom({
  key: "productNoState",
  default: InvalidProductNo,
});
